"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersTab = void 0;
const button_1 = require("client/components/material/button");
const store_1 = require("client/modules/users/store");
const Add_1 = require("material-ui-icons/Add");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const edit_users_1 = require("../../components/edit-users");
const store_2 = require("../../store");
require("./users.less");
let UsersTab = class UsersTab extends react_1.Component {
    componentWillMount() {
        const siteId = Number(this.props.params[0]);
        store_2.sitesDetailStore.loadUsers({ allSites: true, id: siteId });
    }
    render() {
        const siteId = Number(this.props.params[0]);
        const userId = Number(this.props.params[1]);
        return (React.createElement("div", { className: "users__form" },
            store_1.usersStore.permissions.CreateUser && (React.createElement(button_1.MaterialButton, { fab: true, primary: true, className: "add-user-btn", to: `/pharmacies/${siteId}/users/0` },
                React.createElement(Add_1.default, null))),
            React.createElement(edit_users_1.EditUsers, { error: store_2.sitesDetailStore.site.error, loading: store_2.sitesDetailStore.site.loading, site: siteId ? store_2.sitesDetailStore.site.value : null, userId: userId || userId === 0 ? userId : undefined })));
    }
};
UsersTab = __decorate([
    mobx_react_1.observer
], UsersTab);
exports.UsersTab = UsersTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/tabs/users/users.tsx
// module id = 4066
// module chunks = 0